import { useMemo } from 'react';

import useI18n from '../../common/hooks/useI18n';
import { IFlat } from '../../common/model/flat.model';
import { IOffice } from '../../common/model/office.model';
import { FlatType } from '../../common/model/enums/flatType.enum';

import FlatsDisplay from '../shared/flatsDisplay';

type Props = {
  flats: IFlat[];
  neighborsIds: string[];
  offices: IOffice[];
  hasSomeResults: boolean;
};

const MAX_NEIGHBORS = 24;

const NeighborsSection: React.FC<Props> = ({
  flats,
  neighborsIds,
  offices,
  hasSomeResults,
}) => {
  const i18n = useI18n();

  const neighbors = useMemo(() => {
    const neighborsMap = new Map(neighborsIds.map((id) => [id, null]));
    for (const flat of flats) {
      if (neighborsMap.has(flat.id)) {
        neighborsMap.set(flat.id, flat);
      }
    }

    const result = neighborsIds
      .map((id) => neighborsMap.get(id))
      .filter((flat) => !!flat);

    sortNeighbors(result);

    return result.splice(0, MAX_NEIGHBORS);
  }, [flats, neighborsIds]);

  return (
    <div>
      <FlatsDisplay
        flats={neighbors}
        offices={offices}
        title={i18n.t('search.messages.resultsInNearbyZones')}
        centerMode={hasSomeResults}
        arrows={true}
      />
    </div>
  );
};

const sortNeighbors = (neighbors: IFlat[]) => {
  return neighbors.sort((a, b) => {
    if (
      a.type.toUpperCase() === FlatType.PISO &&
      b.type.toUpperCase() !== FlatType.PISO
    )
      return -1;
    if (
      a.type.toUpperCase() !== FlatType.PISO &&
      b.type.toUpperCase() === FlatType.PISO
    )
      return 1;
    return 0;
  });
};

export default NeighborsSection;
